module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4t01Y"))).then(() => parcelRequire('ljYL6'));